import type { Color } from '~shared-components/chakra-theme/'
import { ConfigState } from '~shared-components/redux/reducers/config.reducers'
import {
  DefaultLocale,
  SupportedLocaleCode,
} from '~shared-components/utils/enums'

export const getSupportedLocale = (
  locale: string | undefined,
): SupportedLocaleCode => {
  const upperCaseLocale = locale?.toUpperCase()
  const supportedLocale = Object.values(SupportedLocaleCode).find(
    sl => sl.toUpperCase() === upperCaseLocale,
  )

  return supportedLocale ? supportedLocale : DefaultLocale
}

type SharedLocaleConfig = {
  [T in SupportedLocaleCode]: LocalizedConfiguration
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface LocalizedConfiguration {}

export enum AppEnvironment {
  ACCEPTANCE = 'ACCEPTANCE',
  DEVELOP = 'DEVELOP',
  LOCAL = 'LOCAL',
  PREPRODUCTION = 'PREPRODUCTION',
  PRODUCTION = 'PRODUCTION',
  TEST = 'TEST',
}

export type AppEnvironmentType = keyof typeof AppEnvironment

export const isSupportedEnvironment = (
  environment: unknown,
): environment is AppEnvironmentType =>
  Object.keys(AppEnvironment).includes(String(environment))

export const APP_ENVIRONMENT_COLORS: Record<AppEnvironmentType, Color> = {
  ACCEPTANCE: 'yellow.50',
  DEVELOP: 'green.50',
  LOCAL: 'blue.50',
  PREPRODUCTION: 'violet.50',
  PRODUCTION: 'red.50',
  TEST: 'blue.50',
} as const

export const getEnvironmentTagColor = (
  environment: AppEnvironmentType,
): Color => APP_ENVIRONMENT_COLORS[environment]

export interface ServerConfig {
  allowedCSPWebsites: string[]
}

export interface AppConfig {
  clientConfig: ConfigState
  serverConfig: ServerConfig
  sharedLocaleConfig: SharedLocaleConfig
  ssrConfig: ConfigState
}
